import React, { useEffect } from 'react';
import Add from './Add';

const Edit = ({ data, handleClick }) => {
  useEffect(()=>{
    console.log("Data Changed", data?.automaticPositions)
  }, [data])
  return <Add key={data._id} data={data} handleClick={handleClick} />;
};

export default Edit;
